import React from 'react'
import ReactDOM from 'react-dom'
import './container.scss'
import Toast from './toast'

const ToastContainer = ({ toasts, onDismiss }) => {
  return ReactDOM.createPortal(
    <div className="toast-container">
      {toasts.map(toast => (
        <Toast
          key={toast.id}
          {...toast}
          onClose={() => onDismiss(toast.id)}
        />
      ))}
    </div>,
    document.body
  )
}

export default ToastContainer
